const HALF_AD_TYPE = "half";
const ITEMS_PER_SLIDE_WHEN_MULTI = 5;
const ONE_FOURTH_AD_TYPE = "one_fourth";
const ONE_FOURTH_MIX_AD_TYPE = "one_fourth_mix";
const ONE_THIRD_AD_TYPE = "one_third";
const ITEM_TYPE_CATEGORY = "category";
const ITEM_TYPE_PRODUCT = "product";
const AD_SET_STYLE_ROTATING = "rotating";
const AD_SET_STYLE_STATIC = "static";
const AD_CURATION_COSTCO = "costco";
export {
  AD_CURATION_COSTCO,
  AD_SET_STYLE_ROTATING,
  AD_SET_STYLE_STATIC,
  HALF_AD_TYPE,
  ITEMS_PER_SLIDE_WHEN_MULTI,
  ITEM_TYPE_CATEGORY,
  ITEM_TYPE_PRODUCT,
  ONE_FOURTH_AD_TYPE,
  ONE_FOURTH_MIX_AD_TYPE,
  ONE_THIRD_AD_TYPE
};
